import { useState, useEffect } from "react";
import { ReportServices } from "../../services/ReportServices";
import HospitalCustomPaginaion from "../../utils/HospitalPaginationUtil";
import { handleApiErrorResponses } from "../../utils/ApisErrorHandling";
import { getUser } from "../../config/user";
import { CircularProgress } from "@mui/material";
const HospitalCaseReport = () => {
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedDocType, setSelectedDocType] = useState("ADMISSION");
  let prevDate = new Date();
  prevDate.setDate(prevDate.getDate() - 1);
  const [from, setFrom] = useState(
    prevDate // one day before date
  );
  const [to, setTo] = useState(new Date());
  const limit = 15;
  const [page, setPage] = useState(1);
  const user = getUser();
  const handleStartDateChange = (e) => {
    setFrom(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setTo(e.target.value);
  };
  const formatDate = (date) => {
    date = new Date(date);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed, so we add 1
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  function getTime(minutes) {
    const totalSeconds = minutes * 60;

    const days = Math.floor(totalSeconds / (3600 * 24));
    const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    let result = "";

    if (days > 0) result += `${days}D: `;
    if (hours > 0 || days > 0) result += `${hours}H: `;
    if (mins > 0 || hours > 0 || days > 0) result += `${mins}M `;

    return result;
  }
  const getCasesReport = async () => {
    setLoading(true);
    try {
      const res = await ReportServices.getHsaReportforHsa(
        page,
        limit,
        user?.hospital?.id,
        selectedDocType,
        from,
        to
      );
      setReportData(res?.data?.docTimeReport);
      setTotalPages(res?.data?.totalPages);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setLoading(false);
  };
  useEffect(() => {
    getCasesReport();
  }, [page, from, to, selectedDocType]);

  return (
    <div>
      {" "}
      <div
        style={{ color: "rgba(0,0,0,0.5)" }}
        className="text-[11px] 2xl:text-sm leading-[18.27px] -tracking-[3%]"
      >
        Home / Report
      </div>
      <div className="w-fit text-[30px] 2xl:text-[50px] leading-[65.26px] -tracking-[7%]  mt-[12px] 2xl:mt-[30px]">
        Report
      </div>
      <div className="flex justify-between items-center mt-10">
        <div className="flex gap-5 mb-2">
          <div
            className={` ${
              selectedDocType == "ADMISSION"
                ? "text-white bg-[#191919]"
                : "text-[#191919] bg-white"
            }  border border-solid border-[#191919] px-5 py-3 rounded-full cursor-pointer`}
            onClick={() => {
              setSelectedDocType("ADMISSION");
              setPage(1);
            }}
          >
            Admission
          </div>
          <div
            className={` ${
              selectedDocType == "ENHANCEMENT"
                ? "text-white bg-[#191919]"
                : "text-[#191919] bg-white"
            }  border border-solid border-[#191919] px-5 py-3 rounded-full cursor-pointer`}
            onClick={() => {
              setSelectedDocType("ENHANCEMENT");
              setPage(1);
            }}
          >
            Enhancement
          </div>
          <div
            className={` ${
              selectedDocType == "DISCHARGE"
                ? "text-white bg-[#191919]"
                : "text-[#191919] bg-white"
            }  border border-solid border-[#191919] px-5 py-3 rounded-full cursor-pointer`}
            onClick={() => {
              setSelectedDocType("DISCHARGE");
              setPage(1);
            }}
          >
            Discharge/Claim
          </div>
        </div>
        <HospitalCustomPaginaion
          page={page}
          totalPages={totalPages}
          setPage={setPage}
        />
      </div>
      <div
        id="case-list"
        style={{ background: "rgba(255,255,255,0.5)" }}
        className="p-4 2xl:p-8 mt-1 2xl:mt-4 rounded-[30px] min-h-[70vh]"
      >
        <div className="flex gap-3 mb-4">
          <div>
            <label htmlFor="start-date">Start Date:</label>
            <input
              type="date"
              id="start-date"
              value={formatDate(from)}
              onChange={handleStartDateChange}
              max={formatDate(new Date())}
              style={{ border: "1px solid #E5E5E5" }}
              className="text-[#191919] appearance-none p-2 rounded-[8px] "
            />
          </div>

          <div>
            <label htmlFor="end-date">End Date:</label>
            <input
              type="date"
              id="end-date"
              value={formatDate(to)}
              onChange={handleEndDateChange}
              max={formatDate(new Date())}
              style={{ border: "1px solid #E5E5E5" }}
              className="text-[#191919] appearance-none p-2 rounded-[8px] "
            />
          </div>
        </div>
        <div className="flex text-sm 2xl:text-base gap-1">
          <div
            style={{ border: "1px solid #aaa" }}
            className="w-[30%] grid grid-cols-2 items-center gap-1"
          >
            <div className="px-2">Patient Name</div>
            <div style={{ borderLeft: "1px solid #aaa" }} className="px-2">
              Beneficiary No.
            </div>
          </div>
          <div className="w-[70%]">
            {/* <div className="flex gap-2 items-center ">
              <div
                style={{ border: "1px solid #aaa" }}
                className="w-[45%] text-center py-1"
              >
                Admission
              </div>
              <div
                style={{ border: "1px solid #aaa" }}
                className="w-[10%] text-center py-1"
              >
                Enhancement
              </div>
              <div
                style={{ border: "1px solid #aaa" }}
                className="w-[45%] text-center py-1"
              >
                Discharge/Claim
              </div>
            </div> */}
            <div
              style={{ border: "1px solid #aaa" }}
              className="w-full grid grid-cols-5"
            >
              <div className="text-center px-2">Initiate Time</div>
              <div
                style={{ borderLeft: "1px solid #aaa" }}
                className="text-center px-2"
              >
                Total Docs
              </div>
              <div
                style={{ borderLeft: "1px solid #aaa" }}
                className="text-center px-2"
              >
                1st Doc Upload
              </div>
              <div
                style={{ borderLeft: "1px solid #aaa" }}
                className="text-center px-2"
              >
                Final Doc Upload
              </div>
              <div
                style={{ borderLeft: "1px solid #aaa" }}
                className="text-center px-2"
              >
                Total Reject Document
              </div>
            </div>
          </div>
        </div>
        {loading ? (
          <div className="flex justify-center mt-5">
            {" "}
            <CircularProgress />
          </div>
        ) : (
          reportData?.map((report, idx) => {
            return (
              <div key={idx} className="flex text-xs 2xl:text-sm gap-1 mt-2">
                <div
                  style={{ border: "1px solid #aaa" }}
                  className="w-[30%] grid grid-cols-2 items-center gap-1 py-1"
                >
                  <div className="px-2">{report?.patient?.patientName}</div>
                  <div
                    style={{ borderLeft: "1px solid #aaa" }}
                    className="px-2"
                  >
                    {report?.patient?.beneficiaryNo}
                  </div>
                </div>
                <div className="w-[70%] flex gap-2 items-center">
                  <div
                    style={{ border: "1px solid #aaa" }}
                    className="w-full grid grid-cols-5 py-1"
                  >
                    <div className="text-center px-2">
                      {selectedDocType === "ADMISSION"
                        ? getTime(report?.initiateTimeReport?.admission || 0)
                        : selectedDocType === "DISCHARGE"
                        ? getTime(report?.initiateTimeReport?.claim || 0)
                        : ""}
                    </div>
                    <div
                      style={{ borderLeft: "1px solid #aaa" }}
                      className="text-center px-2"
                    >
                      {report?.[`${selectedDocType}DOCS`]?.totalDocCount || 0}
                    </div>
                    <div
                      style={{ borderLeft: "1px solid #aaa" }}
                      className="text-center px-2"
                    >
                      {report?.[`${selectedDocType}DOCS`]?.firtDocUploadTime
                        ? getTime(
                            report?.[`${selectedDocType}DOCS`]
                              ?.firtDocUploadTime
                          )
                        : "0 M"}
                    </div>
                    <div
                      style={{ borderLeft: "1px solid #aaa" }}
                      className="text-center px-2"
                    >
                      {report?.[`${selectedDocType}DOCS`]?.lastDocUploadTime
                        ? getTime(
                            report?.[`${selectedDocType}DOCS`]
                              ?.lastDocUploadTime
                          )
                        : "0 M"}
                    </div>
                    <div
                      style={{ borderLeft: "1px solid #aaa" }}
                      className="text-center px-2"
                    >
                      {report?.[`${selectedDocType}DOCS`]?.rejectedDocCount ||
                        0}
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default HospitalCaseReport;
